var render = function render(_c, _vm) {
  return _c(
    "wa-question-and-answer",
    {
      attrs: { id: "general-contract-terms", title: "General Contract Terms" },
    },
    [
      _c("template", { slot: "copy" }, [
        _c("h4", { staticClass: "h5 margin-top-2xl" }, [
          _vm._v("Entire Agreement"),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n      These are the final, complete, and only expression of our agreement about\n      "
          ),
          _c("em", [_vm._v("Font Awesome Pro")]),
          _vm._v(".\n    "),
        ]),
        _vm._v(" "),
        _c("h4", { staticClass: "h5 margin-top-2xl" }, [
          _vm._v("Enforcement by the Parties"),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v("\n      Only the\n      "),
          _c("em", [_vm._v("Customer")]),
          _vm._v("\n      and the\n      "),
          _c("em", [_vm._v("Company")]),
          _vm._v("\n      can enforce rights under this agreement.\n    "),
        ]),
        _vm._v(" "),
        _c("h4", { staticClass: "h5 margin-top-2xl" }, [_vm._v("Amendments")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "We will change or add to the terms of this agreement only by cosigning written amendments."
          ),
        ]),
        _vm._v(" "),
        _c("h4", { staticClass: "h5 margin-top-2xl" }, [
          _vm._v("No Assignment"),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v("\n      The\n      "),
          _c("em", [_vm._v("Customer")]),
          _vm._v(
            "\n      may not assign any right or license under this agreement. The\n      "
          ),
          _c("em", [_vm._v("Company")]),
          _vm._v(
            "\n      may assign its rights and obligations under this agreement, as a whole, to a new legal entity created to change its jurisdiction or legal form of\n      organization, or to an entity that acquires\n      "
          ),
          _c("em", [_vm._v("Company")]),
          _vm._v("\n      assets related to\n      "),
          _c("em", [_vm._v("Font Awesome Pro")]),
          _vm._v("\n      or enough securities to control the\n      "),
          _c("em", [_vm._v("Company")]),
          _vm._v(
            "'s management. Any attempt to assign against the terms of this agreement will have no legal effect.\n    "
          ),
        ]),
        _vm._v(" "),
        _c("h4", { staticClass: "h5 margin-top-2xl" }, [
          _vm._v("Arkansas Law"),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "The law of the State of Arkansas will shall govern this agreement."
          ),
        ]),
        _vm._v(" "),
        _c("h4", { staticClass: "h5 margin-top-2xl" }, [
          _vm._v("Terms of Service"),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n      This agreement is also subject to the Terms of Service between the parties. The Terms of Service, available on the fontawesome.com website, are\n      incorporated into this agreement by reference as if fully restated herein. This agreement such Terms of Service shall be read and interpreted together.\n    "
          ),
        ]),
        _vm._v(" "),
        _c("h4", { staticClass: "h5 margin-top-2xl" }, [_vm._v("Disputes")]),
        _vm._v(" "),
        _c("p", [
          _c("strong", [_vm._v("Forum and Arbitration")]),
          _vm._v(
            "\n      - The parties agree that any dispute between them relating in any way to the terms herein shall be subject to mandatory and binding arbitration. Such\n      arbitration shall be conducted by an arbitrator mutually agreeable to the parties and pursuant to the procedural rules of the American Arbitration\n      Association (the “AAA”), though the arbitration need not necessarily be conducted through the AAA. In the event the parties cannot agree to a single\n      arbitrator, each party shall select an arbitrator and the two arbitrators shall select a third, and the subject arbitration shall be conducted by the\n      three arbitrators. All costs for such arbitration shall be shared equally among the parties (with the exception of attorney's fees, which shall be\n      bourne by the party incurring such costs), and the prevailing party shall be entitled to an award of costs and fees against the non-prevailing party. In\n      the event this clause is held invalid or unenforceable, Tthe parties agree that the sole and exclusive jurisdiction for to bring any lawsuits related to\n      this agreement shall be in in the United States District Court for the Western District of Arkansas or the state courts sitting in Bentonville,\n      Arkansas, (the “Designated Courts”).\n    "
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _c("strong", [_vm._v("Exclusive Jurisdiction")]),
          _vm._v(
            "\n      - Each party consents to the exclusive jurisdiction of the\n      "
          ),
          _c("em", [_vm._v("Designated Courts")]),
          _vm._v(
            ", but that exclusive jurisdiction will not prohibit enforcement of any judgment obtained from\n      "
          ),
          _c("em", [_vm._v("Designated Courts")]),
          _vm._v("\n      in any other appropriate forum.\n    "),
        ]),
        _vm._v(" "),
        _c("p", [
          _c("strong", [_vm._v("Inconvenient Forum Waiver")]),
          _vm._v(
            "\n      - Each party waives any objection to venue for lawsuits related to this agreement in the\n      "
          ),
          _c("em", [_vm._v("Designated Courts")]),
          _vm._v(
            ", as well as any claim that a lawsuit related to this agreement in the\n      "
          ),
          _c("em", [_vm._v("Designated Courts")]),
          _vm._v("\n      is brought in an inconvenient forum.\n    "),
        ]),
        _vm._v(" "),
        _c("p", [
          _c("strong", [_vm._v("Indemnity")]),
          _vm._v(
            "\n      - The Customer agrees to indemnify, defend, and hold harmless the Company, its officers, employees, agents, successors, and assigns, against all claims\n      and suits by third parties for damages, injuries to persons (including death), damage to property, loses, and expenses including reasonable attorney's\n      fees, arising out of or from Customer's use of Company's products and services, including all acts by Customer pursuant to this agreement.\n    "
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _c("strong", [_vm._v("Savings")]),
          _vm._v(
            "\n      - If any provision herein, or the application of such provision to any person or circumstance, shall be held invalid by a court or arbitrator, the\n      remainder of the terms herein, or the application of such provision(s) to persons or circumstances other than those as to which it is held invalid,\n      shall not be affected thereby. The remaining terms shall be construed consistently with the terms and stated objectives herein to best give effect to\n      the parties' intent.\n    "
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _c("strong", [_vm._v("Collective, Joint, and Class Waiver")]),
          _vm._v("\n      -\n      "),
          _c("span", { staticClass: "text-uppercase" }, [
            _vm._v(
              "\n        The parties hereto agree that any claims by or among them shall be adjudicated on an individual basis and each of the parties expressly waives their\n        right, if any, to participate in a class, collective, or other joint action concerning any claims by or among them.\n      "
            ),
          ]),
        ]),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }